module.exports = __webpack_public_path__ + "images/stickers/pete-shipped@2x.0d9ff936d513aae5a67c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-shipped@2x.png
// module id = daWC
// module chunks = 12